export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12106.4edf3601.jpg";